var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2Hoursofoperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7824 4.87776L9.81812 2.52313L2.75439 8.41598L4.71852 10.7706L11.7824 4.87776ZM26.1816 2.52429L33.2455 8.41713L31.2812 10.7718L24.2174 4.87891L26.1816 2.52429ZM18.767 12.0127H16.4673V21.2117L23.7498 25.5812L24.8996 23.6954L18.767 20.0618V12.0127ZM18.0004 5.88002C10.3806 5.88002 4.20198 12.0586 4.20198 19.6784C4.20198 27.2982 10.3806 33.4769 18.0004 33.4769C25.6202 33.4769 31.7988 27.2982 31.7988 19.6784C31.7988 12.0586 25.6202 5.88002 18.0004 5.88002ZM7.26832 19.6784C7.26832 25.5964 12.0824 30.4105 18.0004 30.4105C23.9184 30.4105 28.7325 25.5964 28.7325 19.6784C28.7325 13.7604 23.9184 8.94626 18.0004 8.94626C12.0824 8.94626 7.26832 13.7604 7.26832 19.6784Z",
    fill: "#5E5F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2Hoursofoperation);
export default __webpack_public_path__ + "static/media/Icon 2 Hours of operation.dfd19650eb5166c244977cd326806e29.svg";
export { ForwardRef as ReactComponent };